import { AccessTimeFilled } from '@mui/icons-material'
import { useTranslate } from '@tolgee/react'
import { ColoredLabel } from '@tom-ui/ui'
import { formatDateTime } from '@tom-ui/utils'
import { FC } from 'react'

interface IProps {
  releaseValidityDate?: string | null
}

export const ReleaseValidityLabel: FC<IProps> = ({ releaseValidityDate }) => {
  const { t } = useTranslate()

  if (!releaseValidityDate) return null

  return (
    <ColoredLabel
      color='warning'
      startIcon={<AccessTimeFilled fontSize='small' />}
      label={`${t('validTill', 'Valid till')}: ${formatDateTime(releaseValidityDate)}`}
      dataCy='order-release-validity'
      sx={{ alignSelf: 'flex-start' }}
    />
  )
}
